import { render } from "./modalDifficulty&Time.vue?vue&type=template&id=0f973479&scoped=true"
import script from "./modalDifficulty&Time.vue?vue&type=script&lang=js"
export * from "./modalDifficulty&Time.vue?vue&type=script&lang=js"

import "./modalDifficulty&Time.vue?vue&type=style&index=0&id=0f973479&scoped=true&lang=css"

import exportComponent from "/home/usuario/Proyectos/2025/ArkhamHorror/App_Arkham_Horror_3/multigames/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f973479"]])

export default __exports__